import { Component, OnInit } from '@angular/core';
import { MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import moment from 'moment';
import { PopupMessageComponent } from 'src/app/shared/components/popup-message/popup-message.component';
import { ComponentTypes, PropertyTypeId , ActionControl, Status, PartyState, BookingBehavior } from 'src/app/shared/constants/commonenums';
import { BookingChargeType } from 'src/app/shared/dynamicform/models/common-models';
import { ComponentDetails } from 'src/app/shared/dynamicform/models/popup.interface';
import { OperationResultState } from 'src/app/shared/Models/ResultModels';
import { LanguageFileName, operationType } from 'src/app/shared/Models/WidgetSettingsModels';
import { Utilities } from 'src/app/shared/utilities/utilities';
import { ActivitiesListComponent } from '../activities-list/activities-list.component';
import * as _ from 'lodash';

@Component({
    selector: 'app-activity-booking-confirmation',
    templateUrl: './activity-booking-confirmation.component.html',
    styleUrls: ['./activity-booking-confirmation.component.scss', './../activities-lite.component.scss'],
    standalone: false
})
export class ActivityBookingConfirmationComponent extends ActivitiesListComponent implements OnInit {
  bookedReservations = [];
  grandTotal = 0;
  cancellationCharges = 0;
  currency :string;
  cancellationMessage = this.ts.instant('doYouWantToCancelThisReservation');
  bookingToken = '';
  cartBookingId = '';
  cancelSuccessful = false;
  taxIncluded = false;
  cancelRes: any = {};
  bookedActivityCount = 0;
  cancelDialogRef: MatDialogRef<any>;
  noReservationDialog: MatDialogRef<any>;
  widgetSettings: any = {};
  showQRCode = false;
  displayModifyButton : boolean = true;
  displayCancelButton : boolean = true;

  ngOnInit(): void {
    this.activityService.fromConfirmation = false;
    this.activityService.hideBackNav();
    this.activityService.showLanguageOption = false;
    this.activityService.emptyCartData();
    this.activityService.currentNavURL = 'confirmation';
    this.activityService.hideCart.next(true);
    this.activityService.selectedDiningSpecialMeal = null;
    this.bookingToken = this.route.snapshot.params.token;
    this.activityService.restaurantMerchantCode = this.route.snapshot.params.merchantId;
    this.activityService.setSessionData('activityEditData_' + this.activityService.restaurantMerchantCode, {}, true);
    this.currency = this.activityService.OperationCurrency;
    this.getOrderDetails();
    this.getBookingActions();
  }
  getBookingActions(){
    this.displayModifyButton = this.activityService.widgetSettings?.DisplayModifyButton;
    this.displayCancelButton = this.activityService.widgetSettings?.DisplayCancelButton;
    this.route.queryParams
      .subscribe(params => {
        console.log(params);
        if(params?.actionControl !== null && params?.actionControl !== undefined) {
          this.displayModifyButton = Number(params.actionControl) == ActionControl.CanModify || Number(params.actionControl) == ActionControl.CanModifyAndCancel;
          this.displayCancelButton = Number(params.actionControl) == ActionControl.CanCancel || Number(params.actionControl) == ActionControl.CanModifyAndCancel;
        }
      })
  }

  continueToBooking(){
    this.activityService.mealWithConfig = this.activityService.mealWithConfig ? this.activityService.mealWithConfig : (this.activityService.editData?.SpecialMealId && !this.activityService.editData?.SpecialMeal?.ShowOtherActivities ? this.activityService.editData.SpecialMeal : null);
    if(this.activityService.editData){
      this.activityService.editData = null;
    }
    if(this.activityService.sessionFilterValue && Object.keys(this.activityService.sessionFilterValue).length > 0){
      this.activityService.sessionFilterValue = null;
    }
    this.activityService.IsMember = false;
    this.activityService.IsStayGuest = false;
    this.activityService.navigateToPage();
  }


  getOrderDetails(editModify = false, action = '', activityDetails?: any) {
    this.activityService.startLoader();
    this.activityService.byPassValidation = true;
    this.activityService.getByCartId(this.bookingToken, 0).subscribe(result => {
      this.activityService.setLanguageIdFromUrl();
      this.activityService.stopLoader();
      this.activityService.byPassValidation = false;
      if (result) { 
        if (editModify && this.bookedActivityCount > 0 && result.length != this.bookedActivityCount) {
          this.bookedReservations = result;
          this.retryCancelActivity();
        } else if (editModify && this.bookedReservations.length === this.bookedActivityCount) {
          if (action === 'cancel') {
            this.cancelRes = activityDetails;
            // if (!activityDetails.isDining && !activityDetails.isOpenBooking) {              
              this.getCancellationCharges(activityDetails);
            // }
            // else {
            //   this.cancelReservationConfirmation((activityDetails.isDining ? this.ts.instant('Are you sure you want to cancel the reservation?') : this.ts.instant('Are you sure you want to cancel the activity?')) + '<br />', '250px',this.ts.instant('Cancel Reservation'));
            // }
          } else if (action === 'modify') {
            activityDetails.isOpenBooking = 
            this.modifyBooking(activityDetails);
          }
        } else {
          this.bookedReservations = result;
        }
        this.bookedReservations?.forEach(data =>{
          if(data?.BookingContacts?.length > 0){
            data.BookingContacts = data?.BookingContacts?.filter(contact =>
              contact?.BookingContactStates?.some(stateObj => stateObj?.State !=PartyState.Cancelled)
            );
          }
          if(data.BookingAmounts.length > 0){
            data.serviceChargeAmount = _.sumBy(_.filter(data.BookingAmounts, ['BookingChargeType', BookingChargeType.ServiceCharge]), 'Amount');
            data.minRateAdjustmentAmount = _.sumBy(_.filter(data.BookingAmounts, ['BookingChargeType', BookingChargeType.MinRateCoverTypeAdjustment]), 'Amount');
            data.minRateAdjustmentTaxAmount = _.sumBy(_.filter(data.BookingAmounts, ['BookingChargeType', BookingChargeType.MinRateCoverTypeAdjustment]), 'NegotiatedAmount');
       //     data.TaxOnServiceChargeAmount = _.sumBy(_.filter(data.BookingAmounts, ['BookingChargeType', BookingChargeType.ServiceCharge]), 'BookingChargeTaxAmount');
          }
          else{
            data.serviceChargeAmount = 0;
          }
        })
        let index= this.bookedReservations.findIndex(res => !res.CanBeCancel);
        if(index != -1 && this.bookedReservations[index]?.CancellationCutOffDescription) {
          this.activityService.
          openSnackBar(this.bookedReservations[index]?.CancellationCutOffDescription, this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime);
          // return false;
        }
        this.bookedReservations = _.orderBy(this.bookedReservations,'SeatingTime','asc');
        this.bookedActivityCount = this.bookedReservations.length;
        this.activityService.getWidgetImagesMerchantLevel(activityDetails?.MerchantId || result[0].MerchantId);
       
        this.cartBookingId = activityDetails?.CartBookingId || result[0].CartBookingId;
        this.activityService.editData = activityDetails || result[0];
        if(this.activityService.editData.SpecialMeal && !this.activityService.editData.SpecialMeal.ShowOtherActivities && result?.length == 1){
          this.activityService.mealWithConfig = this.activityService.editData.SpecialMeal;
          this.activityService.loadConfigBasedStyles(this.activityService.mealWithConfig);
        }else{
          this.activityService.bannerImageHandler(result);
        }
        this.grandTotalCalculation();
        if(this.activityService.editData.BookedSessions?.length){
          let bookedSessionIds = _.map(this.activityService.editData.BookedSessions,'ActivitySessionId');
          bookedSessionIds.forEach(sessionId => {
            let cancelledSession = _.map(this.activityService.editData.SpecialMeal.ActivitySessions.filter(data => data.StatusCode == Status.Cancelled),'ActivitySessionId').includes(sessionId)
            if(cancelledSession){
              this.activityService.editData.BookedSessions.find(sessionItem => sessionItem.ActivitySessionId == sessionId).State = Status.Cancelled;
              this.toastr.error(`${this.ts.instant('sessionCancellationMsg')} ${this.activityService.editData.SpecialMeal.ActivitySessions.find(data => data.ActivitySessionId == sessionId)?.Reason || ''}.${this.ts.instant('pleaseContact')}`);
              return;
            }
            return;
          })

        }
        this.bookedReservations.map(reservation => {
          if(!reservation.isDining && !reservation.CoverTypeQuantities?.length && reservation.Size) {
            reservation.CoverTypeQuantities = [ {CoverTypeName : (reservation.SpecialMeal?.Name || this.ts.instant('GroupSize')) , CoverTypeId: null, Covers: reservation.Size} ];
          }else if(reservation.isDining && !reservation.CoverTypeQuantities?.length && reservation.Size){
            reservation.CoverTypeQuantities = [ {CoverTypeName : (reservation.SpecialMeal?.Name || this.ts.instant('GroupSize')),CoverTypeId: null, Covers: reservation.Size} ];
          }
        })
      } else {
        this.bookedReservations = [];
        if (editModify) {
          this.retryCancelActivity();
        }
      }
    }, err => {
      this.activityService.stopLoader();
      this.activityService.byPassValidation = false;
      this.bookedReservations = [];
    });
  }

  grandTotalCalculation() {
    this.grandTotal = 0;
    this.showQRCode = false;
    this.bookedReservations.forEach(reservation => {
      reservation.isDining = this.isDining(reservation?.PropertyTypeId);
      reservation.isOpenBooking = this.isOpenBooking(reservation);
      const currentTime =
        Utilities.getRestaurantDateTime(reservation.DaylightDelta);
      const currentDateTime = moment(currentTime);
      const currentDate = moment(currentDateTime.format(moment.HTML5_FMT.DATE));
      reservation.Notes = reservation.Notes.filter(note => note.Type !== 4);
      reservation.cancellationCharges = reservation?.CancellationFeeAmount ? reservation?.CancellationFeeAmount : 0.00;
      reservation.CoverTypeQuantities = reservation.CoverTypeQuantities.filter(cover => { return cover.Covers > 0 });
      reservation.activityStartTime = reservation.isDining || reservation.isOpenBooking ? reservation.ReservedFor : this.findSlot(reservation).startTime;
      reservation.activityEndTime = reservation.isDining || reservation.isOpenBooking ? reservation.DepartureTime : this.findSlot(reservation).endTime;
      reservation.StartDate = reservation.isDining || reservation.isOpenBooking ? reservation.ReservedFor : reservation.StartDate;
      reservation.hideEditCancel = moment(reservation.StartDate) < currentDate ? true : false;
      this.currency = reservation.OperationCurrency;
     // this.grandTotal += ((reservation?.SpecialMealAmount ? reservation?.SpecialMealAmount : reservation?.NoShowFeeAmount)) + (reservation && (reservation.RatePlanAmount ? reservation.RatePlanAmount : 0) + (reservation.AddonItemAmount ? reservation.AddonItemAmount : 0));
     // this.grandTotal += reservation && (reservation.TaxAmount ? reservation.TaxAmount : 0) + (reservation.AddonItemTaxAmount ? reservation.AddonItemTaxAmount : 0) + (reservation.serviceChargeAmount || 0) + (reservation.minRateAdjustmentAmount || 0) + (reservation.minRateAdjustmentTaxAmount || 0) + (reservation.TaxOnServiceChargeAmount || 0);
      this.grandTotal += reservation.GrandTotal;
      this.taxIncluded = reservation.TaxAmount ? true : false;
    });
  }

  findSlot(reservationDetails) {    
    let bookedSessionId = reservationDetails.BookedSessions && reservationDetails.BookedSessions[0] ? reservationDetails.BookedSessions[0].ActivitySessionId : 0;
    let session = reservationDetails.SpecialMeal.ActivitySessions ? reservationDetails.SpecialMeal.ActivitySessions.find(widget => { return widget.ActivitySessionId === bookedSessionId }) : {};
    let activityStartDateTime = session && session.StartTime ? moment(moment().format(moment.HTML5_FMT.DATE) + ' ' + session.StartTime) : '';
    let activityEndDateTime = session && session.EndTime ? moment(moment().format(moment.HTML5_FMT.DATE) + ' ' + session.EndTime) : '';
    return { startTime: activityStartDateTime, endTime: activityEndDateTime };
  }

  isDining(propertyType): boolean {
    if (propertyType && (propertyType === PropertyTypeId.Restaurant || propertyType === PropertyTypeId.Auditorium || propertyType === PropertyTypeId.Cabana || propertyType === PropertyTypeId.MovieTheatre)) {
      return true;
    } else {
      this.showQRCode = true;
      return false;
    }
  }

  isOpenBooking(reservationData: any): boolean {
    if (reservationData 
      && (reservationData.PropertyTypeId === PropertyTypeId.TennisCenter || reservationData.PropertyTypeId === PropertyTypeId.General) 
      && reservationData.SpecialMealId && reservationData?.BookingBehavior == BookingBehavior.OpenBooking) {
      this.showQRCode = true;
      return true;
    } else {      
      return false;
    }
  }


  cancelReservationConfirmation(message, height = '250px',headerTitle?) {
    const popUpMessage = [{
      confirmationMessage: message,
      dialogTitle: headerTitle ? headerTitle : this.ts.instant('cancelActivity'),
      showAlert: true,
      isScrolable: true
    }];
    const componentDetails: ComponentDetails = Utilities.setComponentDetails(PopupMessageComponent, 'small', '', popUpMessage,
      popUpMessage[0].dialogTitle);
    this.cancelDialogRef = this.activityService.openCustomPopup(componentDetails, ComponentTypes.cancelReservation, '400px', height, true, '', this.ts.instant('Yes'),
      this.ts.instant('No'), true, '90vw');
    this.cancelDialogRef.afterClosed().subscribe(data => {
      if (data.ok) {
        if (!this.cancelRes.isDining && !this.cancelRes.isOpenBooking) { this.confirmCancellation(this.cancelRes); }
        else if (this.cancelRes.isDining) { this.confirmDiningCancellation(this.cancelRes); }
        else if (this.cancelRes.isOpenBooking) { this.confirmNonDiningCancellation(this.cancelRes); }
      }
    });
  }

  retryCancelActivity(height = '270px') {
    const popUpMessage = [{
      confirmationMessage: this.ts.instant('retryActivityModify'),
      dialogTitle: this.ts.instant('retryModifyCancel'),
      showAlert: true,
      isScrolable: true
    }];
    const componentDetails: ComponentDetails = Utilities.setComponentDetails(PopupMessageComponent, 'small', '', popUpMessage,
      popUpMessage[0].dialogTitle);
    this.cancelDialogRef = this.activityService.openCustomPopup(componentDetails, ComponentTypes.cancelReservation, '400px', height, true, '', this.ts.instant('continue'),
      this.ts.instant('cancel'), true, '90vw');
  }

  getCancellationCharges(cancelReservation) {
    let alertmsg = this.ts.instant('cancelEntireReservation') + '<br />';
    let height = '250px';
    this.cancellationCharges = 0;    
    this.activityService.startLoader();
    this.activityService.getCancellationCharge(cancelReservation.RestaurantId, cancelReservation.Id, []).subscribe(result => {
      this.activityService.stopLoader();
      if (result && result.Payload && result.Payload.CancellationCharge > 0) {
        this.cancellationCharges = result.Payload.CancellationCharge ? result.Payload.CancellationCharge : 0.00;
        this.ts.get('cancellationFeeInfoMessage', { cancellationcharge: this.currency + this.cancellationCharges, collectTypeInfo: '' }).subscribe(result => {
          this.cancellationMessage = result ? result : this.ts.instant('cancellationFeeInfoMessage') + this.currency + this.cancellationCharges + this.ts.instant('doYouWishToProceed');
        });
        alertmsg += this.cancellationMessage;
        height = '270px';
      }
      this.cancelReservationConfirmation(alertmsg, height);
    });
  }

  confirmCancellation(reservation) {
    this.activityService.startLoader();
    this.activityService.CancelBooking(reservation.RestaurantId, reservation.Id, this.activityService.language, []).subscribe(data => {
      this.activityService.openSnackBar
        (this.ts.instant('reservationCancelledSuccessfully'),
          this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'success-snackbar');
      this.getOrderDetails();
    }, err => {
      this.activityService.stopLoader();
    });
  }

  confirmDiningCancellation(reservation) {
    this.activityService.startLoader();
    this.reservationService.CancelReservation(reservation.RestaurantId, reservation.Id, this.activityService.language).subscribe(data => {
      if (data.State == OperationResultState.Success) {
        this.activityService.openSnackBar
          (this.ts.instant('reservationCancelledSuccessfully'),
            this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'success-snackbar');
        this.getOrderDetails();
      }
    }, err => {
      this.activityService.stopLoader();
    });
  }

  confirmNonDiningCancellation(reservation) {
    this.activityService.startLoader();
    this.activityService.CancelNonDiningBooking(reservation.RestaurantId, reservation.Id).subscribe(data => {
      if (data.State == OperationResultState.Success) {
        this.activityService.openSnackBar
          (this.ts.instant('reservationCancelledSuccessfully'),
            this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'success-snackbar');
        this.getOrderDetails();
      }
    }, err => {
      this.activityService.stopLoader();
    });
  }

  modifyBooking(reservationDetail) {
    this.activityService.operation = operationType.edit;
    this.activityService.editData = reservationDetail || {};
    this.activityService.setSessionData('activityEditData_' + this.activityService.restaurantMerchantCode, reservationDetail, true);
    this.activityService.isDining = reservationDetail.isDining;
    this.activityService.isNonDining = reservationDetail.isOpenBooking || reservationDetail?.BookingBehavior == BookingBehavior.OpenBooking;
    this.activityService.fromConfirmation = true;
    this.activityService.sessionFilterValue = {};
    this.getRestaurantWidgetSettings();
  }
}
